import { useState } from "react";
import { fetchWithAuth } from "../../../../api-client/api_client";
import { showErrorToast } from "../../../shared/Toasts";

interface Props {
  integrationID: string;
}

interface CanaryTestLinkedAccountInfo {
  num_available_las_for_canary_testing: number;
}

const useLoadCanaryTestLinkedAccountInfo = ({ integrationID }: Props) => {
  const [canaryTestLinkedAccountInfo, setCanaryTestLinkedAccountInfo] = useState<
    CanaryTestLinkedAccountInfo | undefined
  >(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchCanaryTestLinkedAccountInfo = () => {
    if (!integrationID) {
      showErrorToast("Integration ID is required");
      return;
    }

    setIsLoading(true);
    fetchWithAuth({
      path: `/integrations/${integrationID}/la-canary-test-info`,
      method: "GET",
      onResponse: (data: CanaryTestLinkedAccountInfo) => {
        setCanaryTestLinkedAccountInfo(data);
        setIsLoading(false);
      },
      onError: () => {
        showErrorToast("Error fetching canary test linked account info");
        setIsLoading(false);
      },
    });
  };

  return {
    canaryTestLinkedAccountInfo,
    fetchCanaryTestLinkedAccountInfo,
    isLoading,
  };
};

export default useLoadCanaryTestLinkedAccountInfo;
